import { ECheckServiceErrorCode } from '../../../redux/reducers';
import { IMappers } from '../../../repositories/billing-tariffs/v3/check-service';
import { ISelectedPromotionInfoSchema } from '../../../repositories/monolith-python/entities/SelectedPromotionInfoSchema';
import { ICheckServiceFail, ICheckServiceSuccess } from '../types';
import { mapAuction } from './mapAuction';
import { mapCheckoutInfo } from './mapCheckoutInfo';
import { mapSelectedPromotionInfo } from './mapSelectedPromotionInfo';

export const mappers: IMappers<ICheckServiceSuccess, ICheckServiceFail> = {
  200: rawResponse => {
    const response = rawResponse || {};
    const selectedPromotionInfo = response.selectedPromotionInfo || ({} as ISelectedPromotionInfoSchema);

    return {
      success: true,
      payload: mapCheckoutInfo(response),
      selectedPromotionInfo: mapSelectedPromotionInfo(selectedPromotionInfo),
      auction: mapAuction(selectedPromotionInfo),
    };
  },
  400: () => ({
    success: false,
    payload: ECheckServiceErrorCode.badRequest,
  }),
};
